import { PATHS } from 'config/routes'
import { useState } from 'react'
import { Button, Container, Form, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import BaseModal from './BaseModal'

function JoinModal({
	show,
	onHide,
	gameId,
	handleDataJoinGame,
	...otherProps
}) {
	const { t } = useTranslation()

	const { roomId } = useParams()

	const [pass, setPass] = useState()
	function handlePassInput(e) {
		setPass(e.target.value)
	}

	// TODO: extract gameId from RoomTable to pass as prop

	return (
		<BaseModal show={show} onHide={onHide} {...otherProps}>
			<Container className="baseinput-container modal-createroom" fluid>
				<Modal.Header>
					<Modal.Title id="contained-modal-title-vcenter" className="join-game">
						{t('modal.join_playroom.join_game')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form>
						<Form.Group className="mb-3 base-input createroom-input">
							<Form.Control
								type="text"
								value={pass}
								onChange={handlePassInput}
								placeholder={t('modal.create_room.room_pass')}
							/>
						</Form.Group>
					</Form>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="dark" onClick={onHide}>
						{t('modal.btn.cancel')}
					</Button>

					<Button
						onClick={() => {
							onHide()
							handleDataJoinGame(pass)
						}}
						variant="secondary"
					>
						{t('modal.btn.agree')}
					</Button>
				</Modal.Footer>
			</Container>
		</BaseModal>
	)
}

export default JoinModal
